import { PageContent, PageWrapper } from '@Component/Page/Page.tsx';
import { Spinner } from '@tlx/atlas';

export const PageLoading = () => {
    return (
        <PageWrapper>
            <PageContent className={'page-loader'}>
                <Spinner size="small" />
            </PageContent>
        </PageWrapper>
    );
};
